import { Button, Carousel, Form, Input, Modal, Dropdown, Menu } from 'antd';
import { SwapRightOutlined } from '@ant-design/icons';
import { useRouterTarget } from '&/utils/customHooks';
import { observer, inject } from 'mobx-react';
import * as Sentry from '@sentry/react';
import Logoes from './Logoes';
import AboutFoxit from '&/components/aboutFoxit';
import { businessCreate } from '&/api/landing';
import { getSMSVerificationCode } from '&/api/Dialogs/signUpDlg';
import ServiceModal from '&/components/ServiceModal';
import usePreviewFiles from '&/utils/customHooks/usePreviewFiles';
import { isBusiness } from '&/utils/common';
import { VIDEO_SOURCES } from '&/utils/constant';
// import { createProject } from '@/api/landingPage/index';
import closeIcon from '@/assets/img/landing/close.svg';
import useExampleProject from '&/utils/customHooks/useExampleProject';

import './LandingPage.scss';
const { Item } = Form;

export default inject('appStore')(
    observer(function LandingPage(props) {
        const carouselRef = useRef();
        const [codeForm] = Form.useForm();
        const [isClicked, setisClicked] = useState(false); // 是否已经点击发送
        const [count, setcount] = useState(60); // 多少秒后可以再次发送
        const [loading, setloading] = useState(false);
        const appStore = props.appStore;
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [visible, setVisible] = useState(false);

        const onVerification = values => {
            setloading(true);
            values.type = 2;
            businessCreate(values)
                .then(({ data }) => {
                    Sentry.withScope(function (scope) {
                        scope.setFingerprint([
                            '{{ default }}',
                            values.mobile,
                            data.id,
                        ]);
                        Sentry.captureMessage(
                            `applications：【一对一服务】[${data.id}] ${values.fullName} ${values.mobile} ${window.location.origin}`,
                            'info'
                        );
                    });
                    setIsModalOpen(true);
                })
                .finally(setloading.bind(null, false));
        };

        const sendCode = async () => {
            // const bl = codeForm.isFieldValidating('mobile');
            await codeForm.validateFields(['mobile']);
            const mobile = codeForm.getFieldValue('mobile');
            await getSMSVerificationCode({
                mobile,
                type: 'LAND',
            });
            setisClicked(true);
            let time = count;
            const timmer = setInterval(() => {
                time--;
                setcount(time);
                if (time !== 0) return;
                clearInterval(timmer);
                setcount(60);
                setisClicked(false);
            }, 1e3);
        };

        const HEADER_LIST = [
            {
                img: require('@/assets/img/landing/Icon_Gift.png').default,
                title: '数据驱动',
                subTitle: '数据看板助力决策',
            },
            {
                img: require('@/assets/img/landing/Icon_Project.png').default,
                title: '项目管理',
                subTitle: '全角色、全生命周期管理',
            },
            {
                img: require('@/assets/img/landing/Icon_Security.png').default,
                title: '专属模板',
                subTitle: '满足个性化流程需求',
            },
            {
                img: require('@/assets/img/landing/Icon_Template.png').default,
                title: '操作至简',
                subTitle: '半天部署，当天上手',
            },
        ];
        const TABS = [
            {
                key: 1,
                title: '项目经理',
                content: {
                    img: require('@/assets/img/landing/4-1.png').default,
                },
                word: [
                    {
                        title: '施工管理',
                        desc: [
                            '施工过程在线有把控，整体进度少延期',
                            '施工模板快速复用，让施工进度有据可依',
                            '预设巡检标准，一键完成巡检',
                        ],
                    },
                    {
                        title: '待办提醒',
                        desc: ['关键节点自动提醒，避免待办堆积遗漏'],
                    },
                    {
                        title: '变更留痕',
                        desc: ['图纸变更留痕实时存储可追溯'],
                    },
                    {
                        title: '到场提醒',
                        desc: ['材料到场提醒，避免施工延期'],
                    },
                ],
            },
            {
                key: 2,
                title: '管理层',
                content: {
                    img: require('@/assets/img/landing/4-2.png').default,
                },
                word: [
                    {
                        title: '数据看板',
                        desc: [
                            '丰富统计维度，助力决策',
                            '提高管理效率，降低40%管理人员数量',
                        ],
                    },
                    {
                        title: '总部管家',
                        desc: [
                            '施工工艺及验收标准直达项目成员，把控工程质量，提高交付效率',
                        ],
                    },
                    {
                        title: '客户留存',
                        desc: ['塑造业主口碑，提高客户留存'],
                    },
                ],
            },
            {
                key: 3,
                title: '业主',
                content: {
                    img: require('@/assets/img/landing/4-3.png').default,
                },
                word: [
                    {
                        title: '业主服务',
                        desc: [
                            '重大变更均需业主同意，细微变动及时通知，化解信任危机',
                        ],
                    },
                    {
                        title: '验收报告',
                        desc: ['各个节点验收报告齐备，施工质量一目了然'],
                    },
                ],
            },
        ];

        const PROBLEM_LIST = [
            {
                title: '融合应用的数据资产',
                desc: '全生命周期多角色数据沉淀， 形成企业数字资产，提高管理效能，助力企业数字化转型升级',
                iconName: require('@/assets/img/landing/6-1.png').default,
            },
            {
                title: '高效互联的协同管理',
                desc: '各方、各专业在线高效协同管理，数据实时互联互通，全过程留痕追溯，赋能家装行业降本提效，提升企业竞争力',
                iconName: require('@/assets/img/landing/6-2.png').default,
            },
            {
                title: '科学规范的监测体系',
                desc: '装修进度实时一手掌握，实时把 控项目进展，有效提高工程质量监控',
                iconName: require('@/assets/img/landing/6-3.png').default,
            },
            {
                title: '安全可靠的信息共享',
                desc: '信息安全流通与数字化赋能，严谨的数据管理为您的信息安全保驾护航，让您无忧家装',
                iconName: require('@/assets/img/landing/6-4.png').default,
            },
        ];

        const PRODUCTION_LIST = [
            {
                title: '智能设计·桌面端',
                description: '智能化、BIM化室内设计软件',
                img: require('&/assets/img/padLanding/productionBG1.png')
                    .default,
                url: '/landing/IntelligentDesign',
            },
            {
                title: '福昕智装·移动端',
                description: '随身必备的装修3D设计运营神器',
                img: require('&/assets/img/padLanding/productionBG2.png')
                    .default,
                url: `${
                    isBusiness() ? '/b/' : '/'
                }landing/IntelligentDesignPad`,
            },
            {
                title: '云服务·尊享版',
                description: '为品质家装提供个性化项目管理服务',
                img: require('&/assets/img/padLanding/productionBG3.png')
                    .default,
                url: '/landing/index',
            },
            {
                title: '云服务·企业版',
                description: '数据赋能装企，专注项目生命周期管理',
                img: require('&/assets/img/padLanding/productionBG4.png')
                    .default,
                url: '/b/landing/index',
            },
        ];

        const targetPage = useRouterTarget();

        const handleApply = () => {
            if (appStore.isLogIn) {
                targetPage({
                    pathname: `/user-center`,
                });
            } else {
                appStore.setApplyTrialDlgVisible(true);
            }
        };

        const [firstIndex, setFirstIndex] = useState(1);

        const videoPreview = usePreviewFiles('video');

        const onFilePreview = () => {
            const file = {
                fileType: '2',
                originalUrl: VIDEO_SOURCES.enterpriseRecommend,
            };
            videoPreview[0](file);
            setTimeout(() => {
                var video = document.getElementById('preview-video');
                video.autoplay = true;
                video.load();
            });
            // setVisible(true);
        };

        const onCilckSampleProject = useExampleProject(appStore);

        const [autoplay, setAutoplay] = useState(true);

        return (
            <div className="landing-page">
                <div className="header">
                    <div className="header-flex">
                        <div className="flex-wrap">
                            <div className="left">
                                {/* <img
                                    src={
                                        require('@/assets/img/landing/image33.png')
                                            .default
                                    }
                                    alt="多端多角色协同"></img> */}

                                <div className="large-title">
                                    福昕家装云服务·企业版
                                </div>
                                <div className="sub-title">
                                    数据赋能装企，专注项目全生命周期管理
                                </div>
                                <div style={{ display: 'none' }}>福昕家装</div>
                                <div style={{ display: 'none' }}>
                                    福昕家装云服务.企业版
                                </div>
                                <div className="btn-warp">
                                    <Dropdown
                                        trigger={['hover']}
                                        overlayClassName="apply_menus"
                                        overlay={
                                            <Menu>
                                                <Menu.Item
                                                    className="menu_item"
                                                    key="1"
                                                    onClick={handleApply}>
                                                    申请试用
                                                </Menu.Item>
                                            </Menu>
                                        }>
                                        <Button
                                            className="primary_btn"
                                            type="primary"
                                            shape="round"
                                            onClick={onCilckSampleProject}
                                            size="large">
                                            免费体验
                                            <SwapRightOutlined className="arrow_icon" />
                                        </Button>
                                    </Dropdown>
                                    <Button
                                        className="preview-video"
                                        shape="round"
                                        type="primary"
                                        size="large"
                                        onClick={onFilePreview}>
                                        <i className="play-icon filled icon-play-circle1" />
                                        播放视频
                                    </Button>
                                </div>
                            </div>
                            <div className="right">
                                <div style={{ display: 'none' }}>福昕家装</div>
                                <div style={{ display: 'none' }}>
                                    福昕家装云服务·企业版
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sub-box-wrap">
                        <div className="flex-box">
                            {HEADER_LIST.map((v, index) => {
                                return (
                                    <div className="box" key={index}>
                                        <img src={v.img} alt={v.title}></img>
                                        <div className="content">
                                            <div className="title">
                                                {v.title}
                                            </div>
                                            <div className="sub-title">
                                                {v.subTitle}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="five-core">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>福昕家装</div>
                            <div style={{ display: 'none' }}>
                                福昕家装云服务
                            </div>
                            存在问题
                        </div>
                        <img
                            className="pk"
                            src={
                                require('@/assets/img/landing/bg-problem.png')
                                    .default
                            }
                        />
                    </div>
                </div>

                <div className="section-four">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>福昕家装</div>
                            <div style={{ display: 'none' }}>
                                福昕家装云服务
                            </div>
                            满足不同角色需求
                        </div>

                        <div className="swiper-tab-wrap">
                            {TABS.map((v, index) => (
                                <div
                                    className="swiper-tab__item"
                                    key={v.key}
                                    onMouseEnter={() => {
                                        setAutoplay(false);
                                    }}
                                    onMouseLeave={() => {
                                        setAutoplay(true);
                                        carouselRef.current.innerSlider.pause(
                                            'play'
                                        );
                                        carouselRef.current.autoPlay('play');
                                    }}
                                    onClick={() => {
                                        if (index === firstIndex) return;
                                        carouselRef.current?.goTo(index);
                                    }}>
                                    <div
                                        className={`content-title ${
                                            firstIndex === v.key - 1
                                                ? 'active'
                                                : ''
                                        }`}>
                                        {v.title}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="carousel-wrap">
                            <Carousel
                                beforeChange={(_, next) => setFirstIndex(next)}
                                autoplaySpeed={5000}
                                autoplay={autoplay}
                                initialSlide={1}
                                pauseOnHover
                                pauseOnDotsHover
                                effect="fade"
                                ref={carouselRef}>
                                {TABS.map((v, index) => (
                                    <div className="carousel-card" key={index}>
                                        <div className="tab-content">
                                            <div className="word-content">
                                                {v.word.map((item, key) => {
                                                    return (
                                                        <div
                                                            className="word-unit"
                                                            key={key}>
                                                            <div className="word-title">
                                                                {item.title}
                                                            </div>
                                                            {item.desc.map(
                                                                (
                                                                    desc,
                                                                    _key
                                                                ) => {
                                                                    return (
                                                                        <div
                                                                            className="word-desc"
                                                                            key={
                                                                                _key
                                                                            }>
                                                                            <div className="dot"></div>
                                                                            <div className="desc">
                                                                                {
                                                                                    desc
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <img
                                                src={v.content.img}
                                                alt={v.title}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </div>

                <div className="example">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>福昕家装</div>
                            <div style={{ display: 'none' }}>
                                福昕家装云服务
                            </div>
                            为什么选择福昕家装？
                        </div>
                        <img
                            src={
                                require('@/assets/img/landing/duibikapian.png')
                                    .default
                            }></img>

                        {/* <Logoes isHDC /> */}
                    </div>
                </div>
                <div className="section-five">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>福昕家装</div>
                            <div style={{ display: 'none' }}>
                                福昕家装云服务
                            </div>
                            省心装修，开创装修新模式
                        </div>

                        <div className="section-five-content">
                            {PROBLEM_LIST.map((v, key) => (
                                <div className="content-item" key={key}>
                                    <div
                                        className="img"
                                        style={{
                                            background: `url(${v.iconName})`,
                                            backgroundSize: 'cover',
                                        }}></div>
                                    <div className="title">{v.title}</div>
                                    <div className="desc">{v.desc}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="section-six">
                    <div className="sub-content">
                        <div className="large-title">
                            <div style={{ display: 'none' }}>福昕家装</div>
                            <div style={{ display: 'none' }}>
                                福昕家装云服务
                            </div>
                            福昕家装·产业链生态合作伙伴
                        </div>

                        <Logoes />
                    </div>
                </div>

                <div className="about-foxit">
                    <div className="sub-content">
                        <div className="content-wrap">
                            <AboutFoxit isHDC />
                        </div>
                    </div>
                </div>
                <div className="free-use">
                    <div className="sub-content">
                        <div className="large-title">一对一服务</div>
                        <Form
                            autoComplete="off"
                            form={codeForm}
                            layout="inline"
                            onFinish={onVerification}>
                            <Item
                                name="fullName"
                                messageVariables={'请输入姓名'}
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入姓名',
                                    },
                                ]}>
                                <Input
                                    allowClear
                                    className="first-item"
                                    placeholder="请输入姓名"
                                />
                            </Item>
                            <Item
                                name="mobile"
                                validateFirst
                                messageVariables={{
                                    label: intl.get('signUpSignIn.phoneNumber'),
                                    // pattern: '手机号格式',
                                }}
                                rules={[
                                    {
                                        required: true,
                                    },
                                    {
                                        pattern: /^1[3456789]\d{9}$/,
                                        message: intl.get(
                                            'signUpSignIn.inputCorrectPhoneNumber'
                                        ),
                                    },
                                ]}>
                                <Input
                                    allowClear
                                    className="first-item"
                                    placeholder={intl.get(
                                        'signUpSignIn.inputPhone'
                                    )}
                                />
                            </Item>

                            <Item
                                name="captcha"
                                messageVariables={{
                                    label: intl.get('signUpSignIn.code'),
                                }}
                                validateFirst
                                rules={[
                                    {
                                        required: true,
                                        len: 6,
                                    },
                                ]}>
                                <Input
                                    type="number"
                                    placeholder={intl.get(
                                        'signUpSignIn.inputCode'
                                    )}
                                    prefix={
                                        <Button
                                            disabled={isClicked}
                                            type="text"
                                            onClick={sendCode}
                                            className="auth-code-btn">
                                            {isClicked
                                                ? intl.get(
                                                      'signUpSignIn.interval',
                                                      { count }
                                                  )
                                                : intl.get(
                                                      'signUpSignIn.getCode'
                                                  )}
                                        </Button>
                                    }
                                />
                            </Item>
                            <Item className="submit-btn-wrap">
                                <Button
                                    className="submitBtn"
                                    block
                                    loading={loading}
                                    type="primary"
                                    htmlType="submit">
                                    联系我们
                                </Button>
                            </Item>
                        </Form>
                        <div className="small-tip">
                            <span>
                                <i className="outlined icon-check-circle"></i>
                                价值999元一对多培训
                            </span>
                            <span>
                                <i className="outlined icon-check-circle"></i>
                                免费赠送优质设计方案
                            </span>
                        </div>
                        <ServiceModal
                            visible={isModalOpen}
                            onCancel={() => setIsModalOpen(false)}
                        />
                    </div>
                </div>
                <div className="producntion-list">
                    <div className="large-title">
                        {intl.get('landingPage.message18')}
                    </div>
                    <div className="production-card-list">
                        {PRODUCTION_LIST.map((production, index) => (
                            <div
                                className="production-card"
                                key={index}
                                onClick={() => window.open(production.url)}>
                                <img
                                    className="background-image"
                                    src={production.img}
                                />
                                <div className="production-card-title">
                                    {production.title}
                                </div>
                                <div className="production-card-content">
                                    {production.description}
                                </div>
                                <div className="view-detail">
                                    {intl.get('base.viewDetail')}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {videoPreview?.[2]}
                <Modal
                    closeIcon={
                        <img className="close-icon" src={closeIcon} alt="" />
                    }
                    onCancel={() => setVisible(false)}
                    visible={visible}
                    width="960px"
                    title={''}
                    centered
                    className="bilibili-video-modal"
                    getContainer={false}
                    footer={null}>
                    <iframe
                        title="bilibili"
                        src="//player.bilibili.com/player.html?aid=492255932&bvid=BV13N411t7ku&cid=1304243621&p=1"
                        scrolling="no"
                        border="0"
                        frameBorder="no"
                        framespacing="0"
                        allowFullScreen={true}></iframe>
                </Modal>
            </div>
        );
    })
);
